var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.interface),expression:"interface"}],staticClass:"input-tel",domProps:{"value":(_vm.interface)},on:{"input":function($event){if($event.target.composing)return;_vm.interface=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }